module.exports = __webpack_public_path__ + "img/footer.d51350e4.png";